import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductStack } from './ProductStack';

/** Checkout de ImpulTienda (tienda Small Engine Diagnostic Pro). */
const CHECKOUT_URL = 'https://small-engine-diagnostic-pro.impultienda.ar/checkout';
const included = ['6 complete volumes, 300 landscape pages', '161 Bench Cards (BC-01–BC-161)', '31 printable shop worksheets', '5 instant-use bonuses', '2- and 4-stroke, 12 machine types', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="topo-light w-full bg-paper-dark text-pine" data-id="element-224" data-mp="25sr3nwyje61r">
      <div className="mx-auto max-w-2xl px-5 py-14 sm:py-20" data-id="element-225" data-mp="20rjvhwshf4uk">
        <div className="text-center" data-id="element-226" data-mp="3h6v3vkvpwqf9">
          <p className="eyebrow text-ember-deep" data-id="element-227" data-mp="3h5tlswgab3o1">Complete package</p>
          <h2 id="pricing-heading" className="trail-underline mt-3 font-display text-[34px] uppercase leading-tight text-pine sm:text-6xl" data-id="element-228" data-mp="3c936wcg7ue47">
            Everything you need at the bench
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-paper-dark bg-white shadow-card" data-id="element-229" data-mp="4v8j6ih8q5db">
          <div className="bg-forest px-5 py-5 text-center" data-id="element-230" data-mp="9qe7fny47w4k">
            <h3 className="font-display text-2xl uppercase text-paper sm:text-3xl" data-id="element-231" data-mp="eq0m81tldkfh">
              Small Engine Diagnostic Pro — Complete Package
            </h3>
            <p className="mt-1 text-[13px] font-bold text-ember" data-id="element-232" data-mp="3i7iqjza5o9b5">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-233" data-mp="3n6d86xwdzrto">
            <div className="rounded-2xl bg-forest-deep px-3 pb-4 pt-5" data-id="element-234" data-mp="3n5aginr8plcp">
              <ProductStack data-id="element-235" data-mp="3rz6brig4cu46" />
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-236" data-mp="2uiptfzhsrvey">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-[15px]" data-id="element-237" data-mp="2zh0ylwx5dhqu">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-moss-soft" data-id="element-238" data-mp="2rgv09f5lnye9">
                    <CheckIcon className="h-3 w-3 text-moss-deep" aria-hidden="true" data-id="element-239" data-mp="2mijnownx79sc" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-paper-dark pt-6 text-center" data-id="element-240" data-mp="2w71q1ibuloy3">
              <p className="text-[13px] text-pine-soft" data-id="element-241" data-mp="28hqtye5g0iqa">
                Regular price{' '}
                <span className="text-pine-muted line-through" data-id="element-242" data-mp="23ixgglq5orq4">$69 USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1" data-id="element-243" data-mp="23la33c6uzq9i">
                <span className="mt-2.5 font-display text-4xl" data-id="element-244" data-mp="2ihhqeldkd7t0">$</span>
                <span className="font-display text-7xl leading-[0.9] sm:text-8xl" data-id="element-245" data-mp="2dg26wxr1b9cq">
                  27
                </span>
                <span className="mt-3 text-[13px] font-bold text-pine-muted" data-id="element-246" data-mp="3ttik8epabmfm">
                  USD
                </span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-247" data-mp="9udk3n4ynj8">
                <span className="rounded border border-ember bg-ember px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-pine" data-id="element-248" data-mp="cq9xnjc545k">
                  Save $42
                </span>
                <span className="rounded border border-paper-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-pine-soft" data-id="element-249" data-mp="3nh63fxftmvao">
                  One-time payment
                </span>
                <span className="rounded border border-paper-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-pine-soft" data-id="element-250" data-mp="j37peqf5q38z">
                  Lifetime access
                </span>
              </div>

              <p className="mt-4 text-sm text-pine-soft" data-id="element-251" data-mp="e9wsbh05d0u9">
                That&apos;s about 17¢ a Bench Card.
              </p>

              <CtaButton href={CHECKOUT_URL} className="mt-4" data-id="element-252" data-mp="11yoe9qn58myl">
                Get Small Engine Diagnostic Pro — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-pine-muted" data-id="element-253" data-mp="16sah6r3i9ch7">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-pine-soft" data-id="element-254" data-mp="3a7w6xx9oeeep">
                <li className="flex items-center gap-1.5" data-id="element-255" data-mp="35adys93hg37r">
                  <LockIcon className="h-4 w-4 text-ember-deep" aria-hidden="true" data-id="element-256" data-mp="317r2nvzs3w4r" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-257" data-mp="1rkny4239sha">
                  <ZapIcon className="h-4 w-4 text-ember-deep" aria-hidden="true" data-id="element-258" data-mp="3sz6vi7rxif3f" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-259" data-mp="3o6vvl4x6utav">
                  <ShieldCheckIcon className="h-4 w-4 text-ember-deep" aria-hidden="true" data-id="element-260" data-mp="3k6v4okswkpmx" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-pine-muted" data-id="element-261" data-mp="frvc2zc0ksyr">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}